var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { BoldSpan, Button, Card, Grid, GridColumn, RightDiv, Separator, StandardDiv } from "@atlassiansox/microscopekit";
import { ButtonGroup } from "@atlaskit/button";
import EditFilledIcon from "@atlaskit/icon/glyph/edit-filled";
import TrashIcon from "@atlaskit/icon/glyph/trash";
import { isEmpty } from "lodash";
export var FaultInputView = function (_a) {
    var faultInput = _a.faultInput, editFc = _a.editFc, deleteFc = _a.deleteFc;
    var tableRows = Object.entries(faultInput.parameters)
        ? Object.entries(faultInput.parameters).map(function (entry) {
            var _a = __read(entry, 2), key = _a[0], val = _a[1];
            var valFormatted = typeof val === "object" ? JSON.stringify(val) : val;
            if (val != null || !isEmpty(val)) {
                return (React.createElement("div", { key: key },
                    React.createElement(BoldSpan, null, key),
                    ":",
                    " ",
                    React.createElement(StandardDiv, null, valFormatted)));
            }
            return null;
        })
        : [];
    return (React.createElement(Card, null,
        React.createElement(Grid, { layout: "flex" },
            React.createElement(GridColumn, { medium: 3 },
                React.createElement("p", null,
                    "Category: ",
                    faultInput.faultCategory),
                React.createElement("p", null,
                    "Action: ",
                    faultInput.faultExecution),
                Boolean(faultInput.delayBeforeExecution) && (React.createElement("p", null,
                    "Delay Before Execution: ",
                    faultInput.delayBeforeExecution,
                    "s"))),
            React.createElement(GridColumn, { medium: 9 },
                React.createElement("div", { hidden: editFc == null || deleteFc == null },
                    React.createElement(RightDiv, null,
                        React.createElement(ButtonGroup, null,
                            React.createElement(Button, { iconBefore: React.createElement(EditFilledIcon, { label: "Edit" }), onClick: function (event) {
                                    if (editFc != null) {
                                        editFc(faultInput);
                                    }
                                } }),
                            React.createElement(Button, { iconBefore: React.createElement(TrashIcon, { label: "Delete" }), onClick: function (event) {
                                    if (deleteFc != null) {
                                        deleteFc(faultInput);
                                    }
                                } })))))),
        React.createElement(Separator, null),
        React.createElement("h4", null, "Parameters"),
        tableRows.length === 0 && React.createElement("p", null, " No parameters"),
        React.createElement("ul", null, tableRows.map(function (value, index) { return (React.createElement("li", { key: "fault-parameter-" + index }, value)); }))));
};
